// Предустановленный список
import autoText from './components/house';

export const AT_TYPE = 'house';

export default autoText;
